import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "deleteActivity",
  tabindex: "-1",
  "aria-labelledby": "deleteActivity",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteActivity"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "modal-body p-0" }
const _hoisted_8 = { class: "text-center py-4 mb-4 border-bottom" }
const _hoisted_9 = { class: "row mx-0 px-0 d-flex justify-content-center flex-sm-row flex-column-reverse mb-4" }
const _hoisted_10 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_11 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4 mb-lg-0" }

import { ref, PropType, onMounted } from 'vue'
import { useStore } from 'vuex'

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'

import communityPortfoliosServices from '@/services/communities-portfolios.service'

import { COMMUNITY_PORTFOLIOS_STORE } from '@/store/constants'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  props: {
  id: String,
  handleDelete: Function as PropType<() => void | undefined>,
  deleteError: Function as PropType<() => void | undefined>,
},
  setup(__props) {

const props = __props

const store = useStore()



// 2022/09/12 TienNV Fix double click button confirm delete
const submittingButton = ref<boolean>(false)
const modalConfirm = ref()
const modalSuccess = ref()

onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('deleteActivity'))
  modalSuccess.value = new Modal(document.getElementById('deleteActivitySuccess'))
})
const onDelete = async (): void => {
  submittingButton.value = true
  props.deleteError(false)

  try {
    const response = await communityPortfoliosServices.deleteActivities(props.id)

    if (response.status === 200) {
      localStorage.removeItem('checkConfirm')
      store.dispatch(COMMUNITY_PORTFOLIOS_STORE.ACTIONS.DELETE_ACTIVITIES_PORTFOLIOS, {
        id: props.id,
      })
      // 2022/09/12 TienNV Fix double click button confirm delete
      modalConfirm.value.hide()
      modalSuccess.value.show()
      setTimeout(() => {
        submittingButton.value = false
      }, 2000)
      return
    } else {
      // localStorage.setItem('serverError', true)
      props.deleteError(true)
      modalConfirm.value.hide()
      modalSuccess.value.show()
      setTimeout(() => {
        submittingButton.value = false
      }, 2000)
    }
  } catch (error) {
    console.log('err', error.response)
    props.deleteError(true)
    modalConfirm.value.hide()
    modalSuccess.value.show()
    // localStorage.setItem('serverError', true)
    submittingButton.value = false
  }
}

onMounted(() => {
  props.handleDelete('')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('deletePersonalActivity')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(translate)('SG49descriptionEditPersonalActivity')), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(Button, {
                title: _unref(translate)('cancel'),
                type: 'secondary',
                "data-bs-dismiss": "modal",
                class: "me-lg-2"
              }, null, 8, ["title"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(Button, {
                title: _unref(translate)('deleteButton'),
                type: 'secondary',
                loading: submittingButton.value,
                disabled: submittingButton.value,
                onClick: onDelete
              }, null, 8, ["title", "loading", "disabled"])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})